export default defineNuxtPlugin(async () => {
  const UseInitStore = useInitStore();
  const { getInitData } = UseInitStore;
  getInitData();
});
